import { useTranslation } from "@opendash/core";
import { _User } from "@opendash/plugin-parse/dist/types-generated";
import { Button, Form, Input, Modal } from "antd";
import Parse from "parse";
import React, { useState } from "react";
import { Agency } from "../js/parsegenerated";
import { TourId } from "../types/TourId";
import { TimeZoneSelect } from "./TimeZoneSelect";

export const AgencyCreateModal = (props: {
  open: boolean;
  onOk: Function;
  onCancel: Function;
}) => {
  const t = useTranslation();
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const save = async () => {
    form.validateFields().then(async (values: Agency) => {
      setLoading(true);

      const agency = new Agency();
      const saved = await agency.save({
        agency_id: values.agency_id ? values.agency_id : crypto.randomUUID(),
        agency_name: values.agency_name,
        agency_url: values.agency_url,
        agency_timezone: values.agency_timezone,
        agency_lang: values.agency_lang,
        agency_phone: values.agency_phone,
        agency_fare_url: values.agency_fare_url,
        agency_email: values.agency_email,
        tenant: (Parse.User.current() as _User).get("tenant"),
      });

      if (!values.agency_id) {
        saved.set("agency_id", saved.id);
        await saved.save();
      }

      props.onOk();
      form.resetFields();
      setLoading(false);
    });
  };

  return (
    <>
      <Modal
        modalRender={(modal) => <div id={TourId.Agency.modal}>{modal}</div>}
        title={t("gtfs:agency.create.modal.title")}
        open={props.open}
        onOk={save}
        onCancel={() => {
          form.resetFields();
          props.onCancel();
        }}
        width={"80%"}
        getContainer={false}
        footer={[
          <Button
            id={TourId.Agency.close}
            key="back"
            onClick={() => {
              form.resetFields();
              props.onCancel();
            }}
          >
            {t("gtfs:global.button.cancel_label")}
          </Button>,
          <Button
            key="submit"
            type="primary"
            loading={loading}
            onClick={save}
            id={TourId.Agency.save}
          >
            {t("gtfs:global.button.save_label")}
          </Button>,
        ]}
      >
        <Form autoComplete="off" form={form} layout="vertical">
          <Form.Item
            name="agency_id"
            label={t("gtfs:agency.create.modal.form.id.label")}
            help={t("gtfs:agency.create.modal.form.id.help")}
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="agency_name"
            label={t("gtfs:agency.create.modal.form.name.label")}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="agency_url"
            label={t("gtfs:agency.create.modal.form.url.label")}
            rules={[
              {
                required: true,
                message: t(
                  "gtfs:agency.create.modal.form.url.rules.required.message"
                ),
              },
              {
                type: "url",
                message: t(
                  "gtfs:agency.create.modal.form.url.rules.type.message"
                ),
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="agency_timezone"
            label={t("gtfs:agency.create.modal.form.timezone.label")}
            rules={[
              {
                required: true,
              },
            ]}
          >
            <TimeZoneSelect />
          </Form.Item>
          <Form.Item
            name="agency_lang"
            label={t("gtfs:agency.create.modal.form.lang.label")}
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="agency_phone"
            label={t("gtfs:agency.create.modal.form.phone.label")}
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="agency_fare_url"
            label={t("gtfs:agency.create.modal.form.fare_url.label")}
            rules={[
              {
                required: false,
              },
              {
                type: "url",
                message: t(
                  "gtfs:agency.create.modal.form.fare_url.rules.type.message"
                ),
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="agency_email"
            label={t("gtfs:agency.create.modal.form.email.label")}
            rules={[
              {
                required: false,
              },
              {
                type: "email",
                message: t(
                  "gtfs:agency.create.modal.form.email.rules.type.message"
                ),
              },
            ]}
          >
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
